import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "export-progress-modal-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "time-hint"
}

import Alert from "@common/components/Alert.vue";
import SpinnerBar from "@common/components/SpinnerBar.vue";
import { ref, watch } from "vue";

//#region General

export default /*#__PURE__*/_defineComponent({
  __name: 'ExportProgressModal',
  props: {
    isExport: { type: Boolean },
    modalShow: { type: Boolean },
    errors: {}
  },
  emits: ["cancel", "update:modalShow"],
  setup(__props: any, { emit: $emit }) {

const props = __props;

const intern_modalShow = ref<boolean>(false);


//#endregion

//#region Show Control
watch(
  () => props.modalShow,
  (nv) => {
    intern_modalShow.value = nv;
  }
);
watch(intern_modalShow, (nv) => {
  $emit("update:modalShow", nv);
});
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    "header-close-content": "",
    ref: "modal",
    id: "export-progress-modal",
    class: "export-progress-modal",
    "body-class": "overflow-auto",
    title: _ctx.$t('ExcelEdit'),
    centered: "",
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    "ok-only": "",
    "ok-title": !props.errors ? _ctx.$t('cancel') : _ctx.$t('Close'),
    "hide-footer": !props.isExport && !props.errors,
    modelValue: intern_modalShow.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((intern_modalShow).value = $event)),
    onOk: _cache[1] || (_cache[1] = ($event: any) => ($emit('cancel'))),
    onHide: _cache[2] || (_cache[2] = ($event: any) => ($emit('cancel'))),
    "data-cy": "excel-edit-progress-mdl"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", null, [
          (!props.errors)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString(props.isExport ? _ctx.$t("creatingExcelEditFile") : _ctx.$t("importingExcelEditFile")), 1))
            : _createCommentVNode("", true),
          (props.errors)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(props.isExport ? _ctx.$t("cantCreateExcelEditFile") : _ctx.$t("cantImportingExcelEditFile")), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(SpinnerBar, {
          "animation-on": !props.errors,
          class: "mb-3"
        }, null, 8, ["animation-on"]),
        (!props.errors)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, null, 512)), [
              [_directive_dompurify_html, _ctx.$t('excelEdit.timeHint')]
            ])
          : _createCommentVNode("", true),
        (props.errors)
          ? (_openBlock(), _createBlock(Alert, {
              key: 1,
              show: "",
              variant: "danger"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(props.errors), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "ok-title", "hide-footer", "modelValue"]))
}
}

})